import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ResolvableMissionType_Create_Mutation =
  graphql(`
    mutation ResolvableMissionTypeForm_ResolvableMissionType_Create(
      $resolvableMissionType: ResolvableMissionTypeInput!
      $versionData: VersionDataInput
    ) {
      createResolvableMissionType(
        doc: $resolvableMissionType
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export type ResolvableMissionTypeInput = VariablesOf<
  typeof ResolvableMissionTypeForm_ResolvableMissionType_Create_Mutation
>['resolvableMissionType'];

export type ResolvableMissionType_Create_Result = ResultOf<
  typeof ResolvableMissionTypeForm_ResolvableMissionType_Create_Mutation
>;

export const useCreateResolvableMissionTypeMutation = () =>
  useGraphQLMutation(
    ResolvableMissionTypeForm_ResolvableMissionType_Create_Mutation,
  );
